<template>
<span class="odr-stars">
    <icon v-for="(_, index) in stars" size="s" :key="'star.' + index">star</icon>
    <icon v-for="(_, index) in half" size="s" :key="'half.' + index">star_half</icon>
    <icon v-for="(_, index) in border" size="s" :key="'border.' + index">star_border</icon>

    <span v-if="showValue === 'true'" class="odr-stars__value">
        {{ showingValue }}
    </span>
    <span class="odr-stars__title">
        <text-regular minor="true" color="gray">
            <slot></slot>
        </text-regular>
    </span>
</span>
</template>

<script>
import '../styles/stars.scss'

export default {
    props: {
        value: {
            default: '0',
            type: String,
            _descr: 'n of stars',
        },
        max: {
            default: '5',
            type: String,
            _descr: 'amount of stars',
        },
        showValue: {
            default: 'true',
            type: String,
            _descr: 'show value after the stars',
        },
    },
    computed: {
        eMax () {
            return parseInt(this.max)
        },
        showingValue () {
            return parseFloat(this.value).toFixed(1)
        },
        eValue () {
            return Math.max(Math.min(parseFloat(this.value), this.eMax) + 0.25, 0)
        },
        stars () {
            return Array(Math.floor(this.eValue)).fill(true)
        },
        half () {
            return (this.eValue - this.stars.length >= 0.5) ? [true] : []
        },
        border () {
            return Array(this.eMax - this.stars.length - this.half.length).fill(true)
        },
    },
    components: {
        icon: require('./icon.vue').default,
        'text-regular': require('./text-regular.vue').default,
    },
}
</script>
